import React, {useEffect} from "react";
import Layout from "./components/Layout";
import {HashRouter, useLocation} from "react-router-dom";
import { Provider } from "react-redux";
import store from "@/store/index";
import zhCN from "antd/locale/zh_CN";
import { ConfigProvider } from "antd";
import "./App.less";
import Home from "@/components/Home";

function App() {
    return (
    <div className="App">
      {/* <React.StrictMode> */}
      <ConfigProvider locale={zhCN}>
        <Provider store={store}>
          <HashRouter>
            {/*<Layout></Layout>*/}
              <Home></Home>
          </HashRouter>
        </Provider>
      </ConfigProvider>
      {/* </React.StrictMode> */}
    </div>
  );
}

export default App;
